class VersioningImpl {
    private dataVersion = 0;
    public lastDataUpdateTime = 0;

    public nextDataVersion(): number {
        return this.dataVersion++;
    }

    public markDataUpdated(): void {
        this.lastDataUpdateTime = Date.now();
    }
}

let instance: VersioningImpl | null = null;
export function getVersioning(): VersioningImpl {
    if (!instance) instance = new VersioningImpl();
    return instance;
}


